const { ERROR_TYPES } = require('../constants');

/**
 * 错误处理器类
 */
class ErrorHandler {
    static classifyError(error) {
        const errorName = error.name || '';
        const errorCode = error.code || '';
        const errorMessage = error.message || '';

        if (error.name === 'QuotaExceededError') {
            return ERROR_TYPES.STORAGE;
        }

        // 用户取消操作
        if (errorName === 'AbortError' || errorMessage.includes('aborted') || errorMessage.includes('cancelled')) {
            return ERROR_TYPES.BUSINESS;
        }

        // 网络错误 - 检查 name, code 和 message
        if (
            errorName === 'NetworkingError' ||
            errorName === 'TimeoutError' ||
            errorName === 'ServiceUnavailable' ||
            errorName === 'ThrottlingException' ||
            errorName === 'TooManyRequestsException' ||
            errorCode === 'NETWORK_ERROR' ||
            errorCode === 'TIMEOUT' ||
            errorMessage.includes('Failed to fetch') ||
            errorMessage.includes('Network Error') ||
            errorMessage.includes('ERR_NETWORK') ||
            errorMessage.includes('ERR_INTERNET_DISCONNECTED') ||
            errorMessage.includes('timeout') ||
            errorMessage.includes('CORS')
        ) {
            return ERROR_TYPES.NETWORK;
        }

        // AWS 特定错误 - 区分可重试和不可重试
        if (
            errorName === 'NoSuchUpload' ||
            errorName === 'InvalidRequest' ||
            errorName === 'AccessDenied' ||
            errorName === 'SignatureDoesNotMatch' ||
            errorName === 'InvalidAccessKeyId' ||
            errorCode === 'NoSuchUpload' ||
            errorCode === 'InvalidRequest' ||
            errorCode === 'AccessDenied'
        ) {
            return ERROR_TYPES.AWS;
        }

        // AWS 可重试错误
        if (
            errorName === 'InternalError' ||
            errorName === 'ServiceUnavailable' ||
            errorName === 'SlowDown' ||
            errorCode === 'InternalError' ||
            errorCode === 'ServiceUnavailable' ||
            errorCode === 'SlowDown' ||
            (error.statusCode && error.statusCode >= 500)
        ) {
            return ERROR_TYPES.SYSTEM;
        }

        // 系统错误
        if (
            errorMessage.includes('system') ||
            errorCode.startsWith('SYS_') ||
            errorMessage.includes('Internal Server Error')
        ) {
            return ERROR_TYPES.SYSTEM;
        }

        // 默认为业务错误
        return ERROR_TYPES.BUSINESS;
    }

    static shouldRetry(error, currentRetries, maxRetries) {
        if (currentRetries >= maxRetries) {
            return false;
        }

        const errorType = this.classifyError(error);

        // 业务错误和AWS错误通常不应重试
        if (errorType === ERROR_TYPES.BUSINESS || errorType === ERROR_TYPES.AWS || errorType === ERROR_TYPES.STORAGE) {
            return false;
        }

        // 网络错误和系统错误可以重试
        return errorType === ERROR_TYPES.NETWORK || errorType === ERROR_TYPES.SYSTEM;
    }

    static getRetryDelay(retryCount, baseDelay = 1000) {
        // 指数退避策略，添加随机抖动避免惊群效应
        const exponentialDelay = baseDelay * Math.pow(2, retryCount);
        const jitter = Math.random() * 0.1 * exponentialDelay; // 10% 随机抖动
        return Math.min(exponentialDelay + jitter, 30000);
    }

    /**
     * 获取错误的详细信息用于日志记录
     */
    static getErrorDetails(error) {
        return {
            name: error.name || 'Unknown',
            code: error.code || 'Unknown',
            message: error.message || 'Unknown error',
            statusCode: error.statusCode || error.$response?.statusCode,
            type: this.classifyError(error)
        };
    }
}

module.exports = ErrorHandler;
